module.exports = __webpack_public_path__ + "img/zh_table3.b097fba9.png";